import { Component, OnInit, Input } from '@angular/core';
import { PersonalPropertyEffects} from '../../model/staterequirements.model';

@Component({
  selector: 'app-state-requirement-personalproperty',
  templateUrl: './state-requirement-personalproperty.component.html',
  styleUrls: ['./state-requirement-personalproperty.component.css']
})
export class StateRequirementPersonalpropertyComponent implements OnInit {
  public role : string;
  public showFlag: boolean = false;
  private _personalPropertyEffects: PersonalPropertyEffects;
  public parClicked: any;
  public agentClicked: any;
  public get personalPropertyEffects(): PersonalPropertyEffects {
    return this._personalPropertyEffects;
  }
  @Input()
  public set personalPropertyEffects(value: PersonalPropertyEffects) {
    if (typeof value !== 'undefined' && value !== null) {
      this._personalPropertyEffects = value;
    }
    else{
      this._personalPropertyEffects = new PersonalPropertyEffects();
    }
  }
  constructor() {
    this._personalPropertyEffects = new PersonalPropertyEffects();
  }

  ngOnInit() {
    this.role = localStorage.getItem("Role");
    this.parClicked = localStorage.getItem("parClicked");
    this.agentClicked = localStorage.getItem("agentClicked");
    if(this.role === "PC PAR Vendor Relations" || this.role === "PC Client" && (this.agentClicked ==="false" && this.parClicked === "false")){
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.parClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.parClicked === "true") {
      this.showFlag = false;
    }
    else
    {
      this.showFlag = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/state-requirement-personalproperty/state-requirement-personalproperty.component.ts